import { omitIsNil } from '@src/utils/omit';
import api from './api';

export const getWithdrawalRequest = async ({ offset, limit, sort, status }) => {
  try {
    const params = omitIsNil({
      offset,
      limit,
      sort,
      status,
    });

    const response = await api({
      method: 'GET',
      url: `/voice-revenue-transactions`,
      params,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

export const getWithdrawalRequestDetail = async (transactionId) => {
  try {
    const response = await api({
      method: 'GET',
      url: `/voice-revenue-transactions/${transactionId}`,
    });
    return response;
  } catch (error) {
    return null;
  }
};

export const cancelWithdrawalRequest = async (withdrawalRequestId) => {
  try {
    const response = await api({
      method: 'POST',
      url: `/voice-revenue-transactions/${withdrawalRequestId}/cancel`,
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};
